import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";
import { EnvelopeIcon, UserGroupIcon } from "@heroicons/react/24/solid";

const Footer = () => {
  return (
    <footer className="bg-primary text-white py-8 mt-5">
      <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:px-16 xl:px-40">
        {/* Single Row Layout */}
        <div className="flex flex-col md:flex-row items-center justify-center md:justify-between space-y-6 md:space-y-0">
          {/* Logo with White Background */}
          <div className="bg-white p-4 rounded-lg shadow-md flex-shrink-0">
            <Link to="/">
              <img
                src="https://surfacepix-media.s3.us-west-2.amazonaws.com/global/Asset_6.png"
                alt="SurfacePix Logo"
                className="w-40 h-auto"
              />
            </Link>
          </div>
          {/* Divider Line */}
          <hr className="w-full md:w-px h-px bg-gray-400 my-4 md:my-0" />

          {/* Buttons Section */}
          <div className="flex flex-wrap justify-center space-x-6 text-sm text-gray-200">
            <Link
              to="/contact"
              className="bg-secondary text-white px-4 py-1.5 rounded-md text-sm font-semibold shadow-md flex items-center space-x-2 hover:bg-secondary/80"
            >
              <EnvelopeIcon className="w-4 h-4 text-white" />
              <span>Contact Us</span>
            </Link>
            {/* <Link
              to="/contact?type=Referral"
              className="bg-secondary text-white px-4 py-1.5 rounded-md text-sm font-semibold shadow-md flex items-center space-x-2 hover:bg-secondary/80"
            >
              <UserGroupIcon className="w-4 h-4 text-white" />
              <span>Referrals</span>
            </Link> */}
          </div>

          {/* Divider Line */}
          <hr className="w-full md:w-px h-px bg-gray-400 my-4 md:my-0" />

          {/* Social Media Icons */}
          <div className="flex space-x-6">
            <a
              href="https://www.instagram.com/surfacepix/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent"
            >
              <FaInstagram className="w-6 h-6 text-white hover:text-accent" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61551456667939"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent"
            >
              <FaFacebookF className="w-6 h-6 text-white hover:text-accent" />
            </a>
            <a
              href="https://www.youtube.com/@SurfacePix"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent"
            >
              <FaYoutube className="w-6 h-6 text-white hover:text-accent" />
            </a>
            <a
              href="https://www.linkedin.com/company/surfacepix/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-accent"
            >
              <FaLinkedinIn className="w-6 h-6 text-white hover:text-accent" />
            </a>
          </div>

          {/* Divider Line */}
          <hr className="w-full md:w-px h-px bg-gray-400 my-4 md:my-0" />

          {/* Privacy Policy */}
          <Link
            to="/privacy-policy"
            className="hover:text-accent text-gray-200"
          >
            Privacy Policy
          </Link>

          {/* Divider Line */}
          <hr className="w-full md:w-px h-px bg-gray-400 my-4 md:my-0" />

          {/* Copyright Section */}
          <div className="text-gray-200">
            &copy; {new Date().getFullYear()} SurfacePix. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
